import React, { Component } from 'react';
import Assets from '../../../../requests/apa/Asset';
import DeviceStorage from '../../../DeviceStorage/DeviceStorage';

class Page01 extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            imageError: false
        }
    }

    render() {
        const region = DeviceStorage.getItem("region");
        const defaultImage = Assets.get('LandingPageClaroTv01_Metadata02_Imagen', '')
        const image = Assets.get(`LandingPageClaroTv01_Metadata02_Imagen_${region}`, '') || defaultImage;
    
        return (
            <div className="landing-page_page page-01">
                <div className="content">
                    <img src={this.state.imageError ? defaultImage : image} 
                        onError={this.state.imageError ? () => {} : () => {
                            this.setState({imageError: true})
                        }}
                    />
                </div>
            </div>
        )
    }
}

export default Page01;


// WEBPACK FOOTER //
// ./src/components/LandingPage/LandingPageSTB/pages/01.jsx